module.exports = __webpack_public_path__ + "ms.svg?830476bcbc2114c0edc9a88954f0816e";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/ms.svg
// module id = 1258
// module chunks = 0